import { render, staticRenderFns } from "./OptionsCreate.vue?vue&type=template&id=6dd9f233"
import script from "./OptionsCreate.vue?vue&type=script&lang=ts"
export * from "./OptionsCreate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports